import React from 'react';
import { Navigate } from 'react-router-dom';
import { getToken, isTokenExpired } from '../utils/auth';

const ProtectedRoute = ({ children }) => {
  const token = getToken();

  if (!token || isTokenExpired(token)) {
    // 2026-10-14: was <Navigate to="/" />, back when "/" was the splash screen. "/" is the static
    // landing page now, which a pushState cannot reach — the router would resolve it in-app — and
    // sign-in is the more useful destination for somebody whose session has simply expired.
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
